export default { sha: 'c4edf9dada19950736174feb980ed8c9f5960b76', buildNumber: 'undefined' }
